import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { BaseFormListComponent } from 'src/app/shared/components/base-form/base-form-list.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { ComposicaoEquipeFormComponent } from './composicao-equipe-form.component';
import { ToastrComponent } from '../util/toastr/toastr.component';
import { Misc } from '../util/misc';
import { Equipe } from 'src/app/models/equipe.model';
import { Gestao } from 'src/app/models/gestao.model';
import { ComposicaoEquipeService } from 'src/app/services/composicao-equipe.service';
import { GestaoService } from 'src/app/services/gestao.service';
import { EquipeService } from 'src/app/services/equipe.service';
import { ValidacaoService } from 'src/app/services/validacao.service';
import { UtilService } from 'src/app/services/util.service';
import { CalculoService } from 'src/app/services/calculo.service';
import { FaturamentoService } from 'src/app/services/faturamento.service';
import { ComposicaoEquipe } from 'src/app/models/composicao-equipe.model';
import { PriceParamProjetoService } from 'src/app/services/price-param-projeto.service';
import { EstimativaGerenciarColaboradorComponent } from '../estimativa/estimativa-gerenciar-colaborador/estimativa-gerenciar-colaborador.component';
import { EstimativaService } from 'src/app/services/estimativa.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { EstimativaColaborador } from 'src/app/models/estimativa-gerenciar-colaborador';
import { environment } from 'src/environments/environment';
import * as constants from 'src/app/models/constants/constants';
import { MotorRecomendacaoEquipeService } from '../../services/motor-recomendacao-equipe.service';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-composicao-equipe-list',
  templateUrl: './composicao-equipe-list.component.html',
  styleUrls: ['./composicao-equipe-list.component.scss'],
})
export class ComposicaoEquipeListComponent extends BaseFormListComponent<Equipe> implements OnInit {
  @Input() estimativaId: number;
  @Input() somenteLeitura: boolean = false;
  @Input() hiddenResume: boolean;
  @Input() mostrarBotao: boolean = true;

  equipes: Equipe[];
  equipesFixo: Equipe[];
  displayedColumns: string[] = [
    'delete',
    'perfil',
    'senioridade',
    'tecnologia',
    'qtd',
    'custoHoraMedio',
    'horaAlocacao',
    'qtdHorasAdotadas',
    'participacao',
  ];

  displayedColumns2: string[] = ['delete', 'nome', 'qtd', 'valor', 'total'];
  dataSource = new MatTableDataSource<Equipe>();
  gestao: Gestao = new Gestao();
  tooltip = 'Temporariamente desativado';

  readonly gestaoId: number;

  totalQtdeProfissional = 0;
  totalAlocacao = 0;
  totalHoraAlocacao = 0;
  quantidadeHorasSugerido = 0;
  totalQtdHorasVenda = 0;
  loading = true;
  disabled = false;
  tipoDelivery: boolean;  
  modalRef: BsModalRef;

  maxTotalAlocacao = 115;
  minTotalAlocacao = 85;

  totalProjeto: number;
  totalGestao: number;

  params: {};
  valorHoraCliente = true;
  valorHoraClienteMin: number;
  valorHoraClienteMax: number;
  estimativaTipo: number;
  estimativaStatus: number;
  priceSimulacao: any;
  tableData: any;
  totalHoras: number;
  colaboradorSelecionado: any;

  cpfColaboradorSelecionado: any;
  equipeId: any;
  colaboradorId: any;

  basicForm: UntypedFormGroup;
  items: any;
  itemsOrdenados: any;
  perfilTipo: any;

  constructor(
    protected composicaoEquipeService: ComposicaoEquipeService,
    private fb: UntypedFormBuilder,
    protected gestaoService: GestaoService,
    protected equipeService: EquipeService,
    private modalService: BsModalService,
    private estimativaService: EstimativaService,
    private validacaoService: ValidacaoService,
    public utilService: UtilService,
    private calculoService: CalculoService,
    private toastr: ToastrComponent,
    private dialog: MatDialog,
    private faturamentoService: FaturamentoService,
    public misc: Misc,
    private priceParamProjeto: PriceParamProjetoService,
    private motorRecomendacaoEquipeService: MotorRecomendacaoEquipeService,
  ) {
    super(equipeService);

    this.gestaoId = environment.gestaoId;

    this.createForm();
  }

  ngOnInit() {
    this.loading = true;

    this.carregarTela();

    this.loading = false;
  }

  carregarTela() {
    this.loading = true;
    this.calcularSimulacao();

    if (this.somenteLeitura) {
      this.displayedColumns.shift();
      this.displayedColumns2.shift();
    }

    this.perfilTipo = JSON.parse(localStorage.getItem('currentUserPricingWeb'))?.perfil[0]?.id;

    this.estimativaService.getEstimativaTipo(this.estimativaId).subscribe((result: any) => {
      this.estimativaTipo = result.estimativaTipoId;
      this.estimativaStatus = result.estimativaStatus;

      if (this.estimativaTipo === constants.TipoEstimativaConstants.ID_TIPO_ESTIMATIVA_DELIVERY) {
        this.tipoDelivery = true;
      }

      if (this.estimativaStatus === constants.EstimativaStatusConstants.ID_ESTIMATIVA_APROVADA) {
        this.somenteLeitura = true;
      }

      if (this.tipoDelivery && this.perfilTipo === constants.PerfilConstants.ID_PERFIL_DELIVERY) {
        this.somenteLeitura = false;
        this.hiddenResume;
      }

      this.carregarEquipeColaborador();

      this.carregarEquipeComHorasEGestao();
    });

    this.getEquipeId();

    this.priceParamProjeto.getByEstimativa(this.estimativaId).subscribe((params) => {
      this.params = params.items;
      this.valorHoraClienteMin = this.params[6].valor;
      this.valorHoraClienteMax = this.params[7].valor;

      if (this.valorHoraClienteMin === 0 && this.valorHoraClienteMax === 0) {
        this.valorHoraCliente = false;
        this.displayedColumns = this.displayedColumns.filter((p) => p !== 'qtdHorasAdotadas');
      }
    });
  }

  carregarEquipeComHorasEGestao() {
    this.loading = true;

    this.gestaoService.getById(this.estimativaId).subscribe({
      next: (ges) => {
        this.gestao = ges;
        this.totalProjeto = ges.totalProjeto;
        this.totalGestao = ges.gestaoInforma;

        forkJoin([
          this.equipeService.getByPropostaId(this.estimativaId),
          this.calculoService.calcularQuantidadeHorasAdotado(this.estimativaId),
        ]).subscribe({
          next: ([equipesResult, horasAdotadas]) => {
            this.equipes = equipesResult.items;
            this.equipesFixo = JSON.parse(JSON.stringify(this.equipes));
            this.dataSource = new MatTableDataSource<Equipe>(this.equipes);
            this.quantidadeHorasSugerido = horasAdotadas;

            this.totalQtdeProfissional = this.getTotalProfissional();
            this.totalAlocacao = this.getTotalAlocacao();
            this.totalHoraAlocacao = this.getTotalHoraAlocacao();
            this.totalQtdHorasVenda = this.getTotalQtdHorasVenda();

            console.log('totalQtdeProfissional', this.totalQtdeProfissional);
            console.log('totalAlocacao', this.totalAlocacao);
            console.log('totalHoraAlocacao', this.totalHoraAlocacao);
            console.log('totalQtdHorasVenda', this.totalQtdHorasVenda);
            console.log('calcularPorcentagemAlocacao', this.calcularPorcentagemAlocacao());

            this.habilitarAba();
          },
          error: (error) => {
            this.toastr.mostrarMensagem('erro', 'Erro', 'Erro ao carregar equipe ou horas adotadas.');
          },
          complete: () => {
            this.loading = false;
          },
        });
      },
      error: (error) => {
        this.toastr.mostrarMensagem('erro', 'Erro', 'Erro ao carregar dados da gestão.');
        this.loading = false;
      },
    });
  }

  createForm() {
    this.basicForm = this.fb.group({
      quantidade: [null, [Validators.required]],
      valor: [null, [Validators.required]],
    });
  }

  habilitarAba() {
    this.validacaoService.validarComposicaoEquipe(this.estimativaId).subscribe((res) => {
      let enabled = res;
      this.utilService.setBoolComposicao(enabled);
      this.utilService.currentBoolComposicao.subscribe((b) => (enabled = b));
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(ComposicaoEquipeFormComponent, {
      width: '600px',
      data: {
        estimativaId: this.estimativaId,
        totalAlocacao: this.totalAlocacao,
        totalHoraProjeto: this.totalProjeto,
        maxTotalAlocacao: this.maxTotalAlocacao,
      },
      panelClass: 'default-dialog-container',
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'ok') {
        this.loading = true;

        this.carregarEquipe();
        this.calculoService.calcularQuantidadeHorasAdotado(this.estimativaId).subscribe({
          next: (horas) => {
            this.quantidadeHorasSugerido = horas;
            this.totalQtdHorasVenda = horas;

            this.recalcularFaturamento(this.estimativaId, 'Profissional adicionado na equipe com sucesso.');
          },
          error: (error) => {
            this.misc.processError(error, 'Ocorreu um erro processando a solicitação.');

            this.loading = false;
          },
        });
      }
    });
  }

  excluir(id: number) {
    this.loading = true;

    if (id > 0) {
      this.equipeService.delete(id).subscribe({
        next: () => {
          this.carregarEquipe();

          this.calculoService.calcularQuantidadeHorasAdotado(this.estimativaId).subscribe({
            next: (result) => {
              this.quantidadeHorasSugerido = result;
              this.totalQtdHorasVenda = result;

              this.recalcularFaturamento(this.estimativaId, 'Profissional excluído da equipe com sucesso.');
            },
            error: (error) => {
              this.misc.processError(error, 'Ocorreu um erro processando a solicitação.');

              this.loading = false;
            },
          });
        },
        error: (error) => {
          this.misc.processError(error, 'Ocorreu um erro processando a solicitação.');

          this.loading = false;
        },
      });
    }
  }

  editar(element: Equipe) {
    const dialogRef = this.dialog.open(ComposicaoEquipeFormComponent, {
      width: '600px',
      data: {
        estimativaId: this.estimativaId,
        totalAlocacao: this.totalAlocacao,
        totalHoraProjeto: this.totalProjeto,
        maxTotalAlocacao: this.maxTotalAlocacao,
        equipe: element,
        isEdit: true,
      },
      panelClass: 'default-dialog-container',
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'ok') {
        // Recarregar a tabela completa com os dados atualizados
        this.carregarEquipeComHorasEGestao();
        
        // Recalcular faturamento após atualizar
        this.calculoService.calcularQuantidadeHorasAdotado(this.estimativaId).subscribe({
          next: (horas) => {
            this.quantidadeHorasSugerido = horas;
            this.totalQtdHorasVenda = horas;

            this.recalcularFaturamento(this.estimativaId, 'Profissional atualizado na equipe com sucesso.');
          },
          error: (error) => {
            this.misc.processError(error, 'Ocorreu um erro processando a solicitação.');
          },
        });
      }
    });
  }

  getHoraProfissional(i: number, cargoId: number) {
    return cargoId === 1 ? this.gestao.gestaoInforma.toFixed(2) : ((this.gestao.totalProjeto * i) / 100).toFixed(2);
  }

  getTotalProfissional() {
    return this.equipes.map((c) => c.composicaoEquipe.qtdProfissional).reduce((acc, value) => acc + +value, 0);
  }

  getTotalAlocacao() {
    const gerente = this.equipes.find((e) => e.profissionalId === 1);
    const alocacoGerente = gerente ? gerente.composicaoEquipe.alocacao : 0;

    return this.equipes.map((c) => c.composicaoEquipe.alocacao).reduce((acc, value) => acc + value, 0) - alocacoGerente;
  }

  getTotalHoras() {
    let totalHoras = 0;

    if (this.equipes !== undefined) {
      this.equipes.forEach((e) => {
        if (e.profissionalId === 1) {
          totalHoras += this.gestao.gestaoInforma;
        } else {
          totalHoras += (this.gestao.totalProjeto * e.composicaoEquipe.alocacao) / 100;
        }
      });
    }

    return totalHoras;
  }

  calcularPorcentagemAlocacao(): number {
    const totalHoraAlocacao = this.getTotalHoraAlocacao();
    const totalProjetoGestao = (this.gestao?.totalProjeto || 0) + (this.gestao?.gestaoInforma || 0);

    if (totalProjetoGestao === 0 || totalHoraAlocacao === 0) return 0;

    return Number(((totalHoraAlocacao / totalProjetoGestao) * 100).toFixed(2));
  }

  getParticipacao(alocacao: number, cargoId: number) {
    if (this.gestao.gestaoInforma === 0 && this.gestao.totalProjeto === 0) {
      return 0;
    }

    const totalHoras = this.getTotalHoras();
    const hora = cargoId === 1 ? this.gestao.gestaoInforma : this.gestao.totalProjeto * (alocacao / 100);

    return Number(((hora / totalHoras) * 100).toFixed(2));
  }

  getTotalParticipacao() {
    let totalParticipacao = 0;

    if (this.equipes !== undefined) {
      this.equipes.forEach((e) => {
        totalParticipacao += this.getParticipacao(e.composicaoEquipe.alocacao, e.profissionalId);
      });
    }

    return totalParticipacao.toFixed(3);
  }

  getQtdHorasVenda(id: number) {
    const equipe = this.equipes.find((e) => e.id === id);
    const participacao = this.getParticipacao(equipe.composicaoEquipe.alocacao, equipe.profissional.cargoId);

    return this.quantidadeHorasSugerido > 0 ? ((this.quantidadeHorasSugerido * participacao) / 100).toFixed(2) : 0;
  }

  getTotalQtdHorasVenda() {
    let totalQtdHorasVenda = 0;

    if (this.equipes && this.equipes.length > 0) {
      this.equipes.forEach((model) => {
        const qtdHorasVenda: number = Number(this.getQtdHorasVenda(model.id));

        totalQtdHorasVenda += qtdHorasVenda;
      });
    }

    return totalQtdHorasVenda;
  }

  carregarEquipeColaborador() {
    this.estimativaService.getEquipeId(this.estimativaId).subscribe((result: any) => {
      const equipeId = result.items[0].composicaoEquipe.equipeId;

      this.estimativaService.getEquipe(equipeId).subscribe((result: any) => {
        this.tableData = result;

        this.loading = false;
      });
    });
  }

  openModal(template: TemplateRef<any>, element: any) {
    this.colaboradorSelecionado = element.nomeColaborador;
    this.cpfColaboradorSelecionado = element.cpfColaborador;

    const valorHora = element.valorHora;
    const quantidadeHora = element.qtdeHora;

    this.modalRef = this.modalService.show(template);

    this.basicForm.controls['valor'].setValue(valorHora);
    this.basicForm.controls['quantidade'].setValue(quantidadeHora);
  }

  pegarColaborador(element: any) {
    this.colaboradorId = element.id;
  }

  enterSave() {
    if (!this.basicForm.valid) {
      return;
    }

    this.save();
    this.getEquipeId();
  }

  save() {
    const dados = {
      id: this.colaboradorId,
      EquipeId: this.equipeId,
      CpfColaborador: this.cpfColaboradorSelecionado,
      ValorHora: this.basicForm.controls['valor'].value,
      QtdeHora: this.basicForm.controls['quantidade'].value,
    } as EstimativaColaborador;

    if (this.basicForm.controls['valor'].value <= 0) {
      this.toastr.mostrarMensagem('aviso', 'Atenção', 'Valor Hora não pode ser igual ou menor que zero');
      this.loading = false;
    } else if (this.basicForm.controls['quantidade'].value <= 0) {
      this.toastr.mostrarMensagem('aviso', 'Atenção', 'Quantidade Hora não pode ser igual ou menor que zero');
      this.loading = false;
    } else {
      this.estimativaService.updateC(dados).subscribe();

      this.loading = true;
      this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Horas alteradas com sucesso');

      this.getEquipeId();
      this.modalRef.hide();
    }
  }

  deleteEquipe(element: any) {
    const colaboradorId = element.id;

    this.estimativaService.deleteEquipe(colaboradorId).subscribe();

    this.loading = true;
    this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Colaborador excluído com sucesso');

    this.getEquipeId();
  }

  carregarEquipe() {
    return this.equipeService
      .getByPropostaId(this.estimativaId)
      .subscribe({
        next: (result) => {
          if (result) {
            this.equipes = result.items;
            this.equipesFixo = JSON.parse(JSON.stringify(this.equipes));
            this.dataSource = new MatTableDataSource<Equipe>(this.equipes);
          }
        },
      })
      .add(() => {
        if (this.equipes.length > 0) {
          this.totalQtdeProfissional = this.getTotalProfissional();
          this.totalAlocacao = this.getTotalAlocacao();
          this.totalHoraAlocacao = this.getTotalHoraAlocacao();
          this.totalQtdHorasVenda = this.getTotalQtdHorasVenda();
          this.habilitarAba();

          console.log('totalQtdeProfissional', this.totalQtdeProfissional);
          console.log('totalAlocacao', this.totalAlocacao);
          console.log('totalHoraAlocacao', this.totalHoraAlocacao);
          console.log('totalQtdHorasVenda', this.totalQtdHorasVenda);
        }
      });
  }

  getTotalHoraAlocacao(): number {
    if (!this.equipes || !this.gestao) {
      return 0;
    }

    const gerente = this.equipes.find((e) => e.profissionalId === 1);
    const alocacoGerente = gerente ? gerente.composicaoEquipe.horaAlocacao : 0;

    const totalHoras = this.equipes.map((c) => c.composicaoEquipe.horaAlocacao).reduce((acc, value) => acc + value, 0);

    const teste = totalHoras + (this.gestao.gestaoInforma || 0);

    return Math.floor(teste);
  }

  updateAlocacao(event: FocusEvent, composicaoEquipe: ComposicaoEquipe) {
    // Não faz nada se estiver no resumo PDF ou em modo somente leitura
    if (this.somenteLeitura || !this.hiddenResume) {
      return;
    }

    this.loading = true;

    if (composicaoEquipe.horaAlocacao <= 0) {
      this.toastr.mostrarMensagem('aviso', 'Atenção', 'Valor não pode ser igual ou menor que zero');

      this.equipes.map((item) => {
        if (item.id === composicaoEquipe.id) {
          const equipeFixo = this.equipesFixo.find((p) => p.id === composicaoEquipe.id);

          item.composicaoEquipe.horaAlocacao = equipeFixo.composicaoEquipe.horaAlocacao;
          item.composicaoEquipe.alocacao = equipeFixo.composicaoEquipe.alocacao;
        }
      });
      this.loading = false;

      return;
    }

    let list = this.equipes;

    const gerente = this.equipes.find((e) => e.profissionalId === 1);

    list = list.filter((item) => item.id !== composicaoEquipe.equipeId);

    if (gerente) {
      list = list.filter((item) => item.id !== gerente.id);
    }

    composicaoEquipe.alocacao = Number(
      ((composicaoEquipe.horaAlocacao / Number(this.gestao.totalProjeto)) * 100).toFixed(2),
    );

    // aqui
    const totalAlocacao = Number(
      (
        list.map((c) => c.composicaoEquipe.alocacao).reduce((acc, value) => Number(acc) + Number(value), 0) +
        Number(composicaoEquipe.alocacao)
      ).toFixed(2),
    );

    this.composicaoEquipeService.update(composicaoEquipe).subscribe({
      next: () => {
        this.carregarEquipe();

        this.calculoService
          .calcularQuantidadeHorasAdotado(this.estimativaId)
          .subscribe({
            next: (result) => {
              this.quantidadeHorasSugerido = result;

              this.recalcularFaturamento(this.estimativaId, 'Horas atualizadas com sucesso.');
            },
            error: (error) => {
              this.misc.processError(error, 'Ocorreu um erro processando a solicitação.');
            },
          })
          .add(() => {
            this.loading = false;
          });
      },
      error: (error) => {
        this.misc.processError(error, 'Ocorreu um erro processando a solicitação.');

        this.loading = false;
      },
    });

    this.calculoService.calcularQuantidadeHorasAdotado(this.estimativaId).subscribe({
      next: (horas) => {
        this.quantidadeHorasSugerido = horas;
        this.totalQtdHorasVenda = horas;

        console.log('horas', horas);

        this.recalcularFaturamento(this.estimativaId, 'Horas atualizadas com sucesso.');
      },
      error: (error) => {
        this.misc.processError(error, 'Ocorreu um erro processando a solicitação.');

        this.loading = false;
      },
    });
  }

  updateComposicaoEquipe(equipe) {
    if (this.somenteLeitura || !this.hiddenResume) {
      this.loading = false;
      return;
    }

    this.loading = true;

    if (equipe.composicaoEquipe.qtdProfissional <= 0) {
      this.toastr.mostrarMensagem('aviso', 'Atenção!', 'A quantidade de profissionais deve ser maior do que zero.');
      this.loading = false;
      this.carregarEquipe();
      return;
    }

    this.composicaoEquipeService
      .update(equipe.composicaoEquipe)
      .subscribe({
        next: () => {
          this.carregarEquipe();
        },
        error: (error) => {
          this.misc.processError(error, 'Ocorreu um erro processando a solicitação.');
        },
      })
      .add(() => {
        this.loading = false;
      });
  }

  recalcularFaturamento(estimativaId: number, mensagemConclusao: string) {
    this.faturamentoService.recalcularFaturamento(estimativaId).subscribe(
      (faturamento) => {
        this.toastr.mostrarMensagem('sucesso', 'Sucesso', mensagemConclusao);
      },
      (error) => {
        this.misc.processError(error, 'Não foi possível recalcular o pricing.');
      },
      () => {
        this.loading = false;
      },
    );
  }

  recalcularCustoHora(equipe: Equipe) {
    equipe.custoHora = Number(equipe.custoHora.toString().replace(',', '.'));

    this.equipeService.update(equipe).subscribe(() => {
      this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Custo Hora atualizado!');
      this.loading = false;
    });
  }

  openGerenciarColaboradores(): void {
    const dialogRef = this.dialog.open(EstimativaGerenciarColaboradorComponent, {
      width: '600px',
      data: {
        usuarioId: this.utilService.getUserId(),
        estimativaId: this.estimativaId,
      },
      panelClass: 'default-dialog-container',
    });

    dialogRef.afterClosed().subscribe(() => {
      this.calcularSimulacao();
      this.getEquipeId();
      //this.pesquisar(true);
    });
  }

  calcularSimulacao() {
    this.loading = true;
    this.calculoService.calcularSimulacao(this.estimativaId).subscribe(
      (result) => {
        this.priceSimulacao = result.objeto;
      },
      (error) => {
        this.misc.processError(error, 'Não foi possível calcular o pricing.');
      },
    );
  }

  getEquipeId() {
    this.estimativaService.getEquipeId(this.estimativaId).subscribe((result: any) => {
      this.equipeId = result.items[0].composicaoEquipe.equipeId;

      this.estimativaService.getEquipe(this.equipeId).subscribe((result: any) => {
        this.tableData = result;

        this.loading = false;
      });
    });

    this.calcularSimulacao();
  }

  updateEquipe(equipe: Equipe) {
    if (equipe.cooperado) {
      equipe.custoHora = equipe.profissional.custoCooperado;
    } else {
      equipe.custoHora = equipe.profissional.custoHoraMedio;
    }

    this.recalcularCustoHora(equipe);
  }

  gerarEquipeComIA() {
    this.loading = true;

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {
        titulo: 'Geração de Equipe com IA',
        texto:
          'Atenção! Essa ação irá substituir toda a Equipe atual por uma nova baseada em todas as Métricas dos Requisitos da Estimativa. Confirma ação?',
      },
      panelClass: 'default-dialog-container',
    });

    dialogRef.afterClosed().subscribe((resultModal) => {
      if (resultModal) {
        this.loading = true;
        this.motorRecomendacaoEquipeService.gerarEquipe(this.estimativaId).subscribe((resultRequest: any) => {
          if (resultRequest.mensagem == null) {
            this.carregarTela();
          } else {
            this.misc.processError(resultRequest.mensagem);
          }
          this.loading = false;
        });
      }
    });
    this.loading = false;
  }
}
